module.exports = __webpack_public_path__ + "img/empty-wallet.ddda8eae.png";